import React, { useCallback, useState } from 'react'
import { isEmptyString } from '../../../../utils/string-utils'
import { IconButton, Tooltip } from '@mui/material'
import OrderManagerModal from './order-manager-modal'
import ManageHistoryIcon from '@mui/icons-material/ManageHistory'

export interface ViewOrderManagerInfoModalTriggerProps {
  strategyId: string
  strategyName: string
  isApiConnected: boolean
  orderManagerInfoUrl: string | null
  controlOrderManagerCommandUrl: string | null
}

const OrderManagerModalTrigger: React.FC<ViewOrderManagerInfoModalTriggerProps> = (props) => {
  const { strategyId, strategyName, isApiConnected, orderManagerInfoUrl, controlOrderManagerCommandUrl } = props
  const isDisabled = !isApiConnected || isEmptyString(orderManagerInfoUrl)

  const [isModalOpen, setIsModalOpen] = useState<boolean>(false)

  const openModal = useCallback(() => {
    setIsModalOpen(true)
  }, [])

  const closeModal = useCallback(() => {
    setIsModalOpen(false)
  }, [])

  return (
    <>
      <OrderManagerModal
        open={isModalOpen}
        onClose={closeModal}
        strategyId={strategyId}
        title={`${strategyName} Order Manager Info`}
        dataUrl={orderManagerInfoUrl}
        postUrl={controlOrderManagerCommandUrl}
      />

      <Tooltip title='View order manager info'>
        <span>
          <IconButton size='small' disabled={isDisabled} onClick={openModal}>
            <ManageHistoryIcon/>
          </IconButton>
        </span>
      </Tooltip>
    </>
  )
}

export default React.memo(OrderManagerModalTrigger)
